import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUserAccess } from '../../hooks/useRole';
import NewLayout from '../../layout/dashboard/NewLayout';
import DefectIntelligence from '../../components/defects/Defectclassifier';

const DefectIntelligencePage = () => {
  const navigate = useNavigate();
  const { canSeeAllDefects, isError, isLoading, projectIds } = useUserAccess();

  useEffect(() => {
    if (!isLoading && !isError && !canSeeAllDefects) {
      navigate('/access-denied');
    }
  }, [canSeeAllDefects, isLoading, isError, navigate]);

  return (
    <NewLayout>
      {!isLoading && (!projectIds || projectIds.length === 0) ? (
        <p className="text-center" style={{ fontSize: '16px' }}>
          You do not have admin access to any projects. Please contact your
          administrator to resolve this issue.
        </p>
      ) : (
        <DefectIntelligence projectIds={projectIds} />
      )}
    </NewLayout>
  );
};

export default DefectIntelligencePage;
